import React from 'react'
import PropTypes from 'prop-types'
import RecommendedProducts from '../../../recommended-products'
import {Box} from '@chakra-ui/react'

export const RecommendationsEinstein = ({
    title,
    titleColor = 'black',
    titleTag = 'h2',
    pageData = null,
    dataLayerLoaded = true,
    titleFontFamily,
    recommender,
    typeId,
    name
}) => {
    const trackingProps = {
        component_id: typeId,
        component_name: title || name || typeId
    }
    return (
        <Box sx={{'.swiper-parent': {width: 'unset'}}}>
            <RecommendedProducts
                title={title}
                titleColor={titleColor}
                titleTag={titleTag}
                dataLayerLoaded={dataLayerLoaded}
                titleFontFamily={titleFontFamily}
                recommender={recommender}
                pageData={pageData}
                hideArrows={false}
                showImageSlider={true}
                sliderGroup="product"
                analyticsProps={trackingProps}
            />
        </Box>
    )
}

RecommendationsEinstein.propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    titleFontFamily: PropTypes.string,
    pageData: PropTypes.any,
    dataLayerLoaded: PropTypes.bool,
    titleTag: PropTypes.string,
    recommender: PropTypes.string,
    typeId: PropTypes.string,
    name: PropTypes.string
}

export default RecommendationsEinstein
